const token = 'xoxb-2642675094-2244229498659-ptE8WrzNzSiyO66rqX69Tts6';

// #esop-feedback
const channel = 'C026XH9A12B';
// #esop-feedback-test
const channelForTest = 'C027AV8A57F';
abstract class SlackAPI {
  env: string;
  summary: string;
  description: string;

  constructor(env: string, summary: string, description: string) {
    this.env = env;
    this.summary = summary;
    this.description = description;
  }

  abstract get url(): string;
  abstract get formdata(): FormData;

  get channel(): string {
    // mock or localの場合はテスト用channelへpost
    // appInfo.envNameが万が一取れなかった'unknown'で渡ってくるので、その場合も一応テスト用channelにpostするようにする
    if (this.env == 'mock' || this.env == 'local' || this.env == 'unknown') {
      return channelForTest;
    }
    return channel;
  }

  async perform(): Promise<string> {
    const body = this.formdata;
    // console.log(...body.entries());
    const resp = await fetch(this.url, {
      method: 'POST',
      cache: 'no-cache',
      body: body,
    });
    return await resp.text();
  }
}

class PostMessageAPI extends SlackAPI {
  constructor(env: string, summary: string, description: string) {
    super(env, summary, description);
  }
  get url(): string {
    return 'https://slack.com/api/chat.postMessage';
  }
  get formdata(): FormData {
    const blocks = JSON.stringify([
      {
        type: 'section',
        text: {
          type: 'plain_text',
          text:
            `--------------------------------------------------------------\n` +
            `Environment:\n${this.env}` +
            `\n\n` +
            `Summary:\n${this.summary}` +
            `\n\n` +
            `Description:\n${this.description}` +
            `\n\n` +
            `UserAgent:\n${navigator.userAgent}`,
        },
      },
    ]);

    const formdata = new FormData();
    formdata.append('token', token);
    formdata.append('channel', this.channel);
    formdata.append('blocks', blocks);
    // blocksが表示されない時のfallback? 通常は表示されない
    formdata.append('text', `${this.summary}\n\n${this.description}`);
    return formdata;
  }
}

class FileUploadAPI extends SlackAPI {
  file: File;
  constructor(env: string, summary: string, description: string, file: File) {
    super(env, summary, description);
    this.file = file;
  }
  get url(): string {
    return 'https://slack.com/api/files.upload';
  }
  get formdata(): FormData {
    const formdata = new FormData();
    formdata.append('token', token);
    formdata.append('channels', this.channel);
    formdata.append(
      'initial_comment',
      `--------------------------------------------------------------\n` +
        `Environment:\n${this.env}` +
        `\n\n` +
        `Summary:\n${this.summary}` +
        `\n\n` +
        `Description:\n${this.description}` +
        `\n\n` +
        `UserAgent:\n${navigator.userAgent}`
    );
    // ファイルの名前からMacユーザ/Windowsユーザぐらいはわかってしまうので
    // 匿名度に影響を与えないようにファイル名はscreenshotで統一する
    formdata.append('title', this.fileName);
    formdata.append('filename', this.fileName);
    formdata.append('file', this.file);
    return formdata;
  }
  get fileName(): string {
    const base = 'screenshot';
    const ext = this.file.name.split('.').pop();
    if (!ext) {
      return base;
    }
    if (ext === this.file.name) {
      // 拡張子がない が、input tagでaccept="image/*"の制約を設けているのでありえないはず
      return base;
    }
    return base + '.' + ext;
  }
}

function createSlackAPI(
  env: string,
  summary: string,
  description: string,
  file: File | null
): SlackAPI {
  if (file) {
    return new FileUploadAPI(env, summary, description, file);
  } else {
    return new PostMessageAPI(env, summary, description);
  }
}

export { SlackAPI, createSlackAPI };
